import React from "react";
import { Box, Typography, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import gitasevalogo from "../../Images/logoGST.png";
import googlePlayBadge from "../../assets/img/android-app.png";
import appStoreBadge from "../../assets/img/ios-app.png";

const DownloadAppPage = ({ onClose }: { onClose?: () => void }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="download-app-dialog-title"
      PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden" } }}
      sx={{ "& .MuiDialog-paper": { overflowY: "visible" } }}
    >
      <DialogTitle
        id="download-app-dialog-title"
        sx={{ m: 0, p: { xs: 1.5, sm: 2 }, textAlign: "center", position: "relative" }}
      >
        {t("download_app_title_tr")}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
            bgcolor: "#f57c00",
            "&:hover": { bgcolor: "#e65100" },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 2, sm: 3 }, py: { xs: 1, sm: 2 }, maxHeight: "85vh" }}>
        <Box sx={{ textAlign: "center" }}>
          {/* Additional Description */}
          <Box
            sx={{
              border: "1.5px solid #f57c00",
              borderRadius: "8px",
              p: { xs: 1, sm: 1.5 },
              mb: { xs: 1.5, sm: 3 },
            }}
          >
            <Typography
              sx={{
                color: "#f57c00",
                fontWeight: "bold",
                fontSize: { xs: "16px", sm: "18px" },
                lineHeight: 1.6,
              }}
            >
              {t("download_app_additional_desc_tr")}
            </Typography>
          </Box>

          {/* Logo + App Name Row */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: { xs: 1.5, sm: 2 },
              mb: { xs: 2, sm: 3 },
            }}
          >
            <Box
              component="img"
              src={gitasevalogo}
              alt="Gita Seva"
              sx={{
                width: { xs: 55, sm: 85 },
                borderRadius: "16px",
              }}
            />
            <Typography
              sx={{
                color: "#f57c00",
                fontFamily: "ChanakyaUni",
                fontWeight: "bold",
                fontSize: { xs: "22px", sm: "34px" },
                letterSpacing: "0.5px",
              }}
            >
              {t("download_app_heading_tr")}
            </Typography>
          </Box>

          {/* Description */}
          <Typography
            sx={{
              color: "text.secondary",
              fontSize: { xs: "15px", sm: "17px" },
              lineHeight: 1.5,
              mb: { xs: 0.5, sm: 1 },
            }}
          >
            {t("download_app_desc_tr")}
          </Typography>
          <Typography
            sx={{
              color: "#f57c00",
              fontWeight: "bold",
              fontSize: { xs: "15px", sm: "17px" },
              lineHeight: 1.5,
              mb: { xs: 2, sm: 4 },
            }}
          >
            {t("download_app_desc_highlight_tr")}
          </Typography>

          {/* Stats */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              gap: { xs: 2, sm: 4 },
              width: "90%",
              mx: "auto",
              mb: { xs: 2, sm: 4 },
            }}
          >
            <Box>
              <Typography fontWeight="bold">4.9★</Typography>
              <Typography variant="caption">{t("rating_tr")}</Typography>
            </Box>
            <Box>
              <Typography fontWeight="bold">1M+</Typography>
              <Typography variant="caption">{t("downloads_tr")}</Typography>
            </Box>
            <Box>
              <Typography fontWeight="bold">24x7</Typography>
              <Typography variant="caption">{t("spiritual_access_tr")}</Typography>
            </Box>
          </Box>

          {/* Store Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              mb: { xs: 1, sm: 3 },
            }}
          >
            <Box
              component="a"
              href="https://play.google.com/store/apps/details?id=ct.android.gitasevakotlin"
              target="_blank"
              sx={{ display: "block" }}
            >
              <Box
                component="img"
                src={googlePlayBadge}
                alt="Get it on Google Play"
                sx={{ height: { xs: 36, sm: 48 }, display: "block" }}
              />
            </Box>
            <Box
              component="a"
              href="https://itunes.apple.com/us/app/gita-seva-app/id1418594830"
              target="_blank"
              sx={{ display: "block" }}
            >
              <Box
                component="img"
                src={appStoreBadge}
                alt="Available on App Store"
                sx={{ height: { xs: 36, sm: 48 }, display: "block" }}
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadAppPage;
